import uniqid from 'uniqid'
import GitHubIcon from '@mui/icons-material/GitHub';
import LaunchIcon from '@mui/icons-material/Launch';
import './ProjectContainer.css'

const ProjectContainer = ({ project }) => (
  <div className='project'>
    <h3>{project.name}</h3>
    <div>
      <img src = {project.image} alt="mamaearth_icon" width="300px" height="200px" style={{padding:"10px"}}/>
    </div>

    <p className='project__description' style={{textAlign:"center"}}>{project.description}</p>
    {project.stack && (
      <ul className='project__stack'>
        {project.stack.map((item) => (
          <li key={uniqid()} className='project__stack-item' 
          style={{background:"#2978B5",color:"white",padding:"5px",borderRadius:"5px"}}>
            {item}
          </li>
        ))}
      </ul>
    )}

    {project.sourceCode && (
      <a
        href={project.sourceCode}
        aria-label='source code'
        className='link link--icon'
        target="_blank"
      >
        <GitHubIcon />
      </a>
    )}

    {project.livePreview && (
      <a
        href={project.livePreview}
        aria-label='live preview'
        className='link link--icon'
        target="_blank"
      >
        <LaunchIcon />
      </a>
    )}
  </div>
)

export default ProjectContainer
